import { useContext } from 'react';
import { ToastContext } from '.';

export default function useToastContext() {
  return useContext(ToastContext);
}
